import React from "react";
import {
    CommonDiscussParams,
    DiscussDetail,
    ReplyItemData,
    SortType,
    TopicType
} from "../../../API/discuss";
import { CourseDetail } from "../../CourseDetail/Store";

interface DiscussContentProps extends CommonDiscussParams {
    topicType: TopicType; // 主题类型（0主题讨论 1答疑）
    uuid: string;
    sort: SortType;
    loading: boolean; // 是否在加载
    isWriting: boolean; // 是否在编辑答案
    setIsWriting(isWriting: boolean): void;
    setSort(sort: SortType): void;
    discussDetail?: DiscussDetail | null;
    updateDiscussDetail(): void;
    course?: CourseDetail | null;
    isDead: boolean; //  是否截止
    editUuid: string | null; // 是否在编辑答案
    setEditUuid(isWriting: string | null): void;
}

export const DiscussContent = React.createContext<DiscussContentProps>({
    topicType: TopicType.Discuss,
    uuid: "",
    courseNo: "",
    courseSeq: "",
    course: null,
    batchNo: "",
    sort: SortType.All,
    loading: false,
    isWriting: false,
    setIsWriting() {},
    isDead: false,
    editUuid: null,
    setEditUuid() {},
    setSort() {},
    updateDiscussDetail() {}
});

interface AnswerContentProps {
    answerData: ReplyItemData;
    replyCount: number;
}

// 回答贴
export const AnswerContent = React.createContext<AnswerContentProps>({} as any);
